module.exports = __webpack_public_path__ + "img/musei-del-cibo.3721f809.png";